import React from 'react';
import Layout from '../../components/layout';
import { Link } from 'gatsby';
import Ogp from '../../components/ogp';
import styled from 'styled-components';
import { cardData } from '../../data';

const JugglersIndex: React.FC<{}> = () => {
  return (
    <Layout>
      <Ogp isRoot={false} />
      <div style={{ background: '#fff' }}>
        <div className="wrapper">
          <h2 className="section-headline">Jugglers</h2>
          <List>
            {cardData.map((data) => (
              <ListItem>
                <CardLink to={data.detailUrl}>
                  <Image src={data.picUrl} />
                  <div>{data.name}</div>
                </CardLink>
              </ListItem>
            ))}
          </List>
        </div>
      </div>
    </Layout>
  );
};

export default JugglersIndex;

const Image = styled.img`
  width: 100%;
  margin-bottom: 10px;
`;

const List = styled.ul`
  display: flex;
  flex-direction: row;
  list-style: none;
  padding: 0;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const ListItem = styled.li`
  flex-basis: 49%;
  margin-bottom: 20px;
`;

const CardLink = styled(Link)`
  text-decoration: none;
`;
